module.exports = __webpack_public_path__ + "static/media/loanExists.0cb8782c.svg";